import React from 'react';
import { TOTAL_PROJECTS } from '../data/books';
export function WelcomeLetter() {
  return <section aria-labelledby="letter-heading" className="scroll-mt-24" data-id="element-257" data-mp="16i4258mcg07h">
      <div className="border-t-2 border-ink/12 pt-5" data-id="element-258" data-mp="16kyk8thvx8xq">
        <div className="flex items-baseline gap-4" data-id="element-259" data-mp="12htjavdgdfb7">
          <span className="tnum font-sans text-[11px] font-semibold tracking-[0.18em] text-gold" data-id="element-260" data-mp="xhxhn2s89zyt">
            01
          </span>
          <h2 id="letter-heading" className="font-display text-[26px] font-semibold leading-tight text-ink sm:text-[32px]" data-id="element-261" data-mp="1u8g8if1xxovy">
            A letter to the household
          </h2>
        </div>
      </div>

      <div className="mt-8 max-w-measure sm:ml-[46px]" data-id="element-262" data-mp="1le1usgx26mey">
        <p className="font-sans text-[18px] leading-[1.62] text-ink" data-id="element-263" data-mp="1ghl3jdukbrxn">
          Every project in these twelve books began at a kitchen table, usually with the wrong
          materials. A tower of dry spaghetti that fell over four times before it stood. A glider
          that flew beautifully once and then never again. We wrote all of it down, including the
          failures, because the failures are the part children remember.
        </p>
        <p className="mt-6 font-sans text-[16px] leading-[1.7] text-ink/75" data-id="element-264" data-mp="26vlln4jr90n6">
          The Workshop is where the collection lives in full: {TOTAL_PROJECTS} projects across
          twelve books, each one indexed by age, by how long it takes, by how hard it is and by how
          much of your floor it will cover. Every book downloads whole, or opens as a list so you
          can find a single page without scrolling through a PDF.
        </p>
        <p className="mt-6 font-sans text-[16px] leading-[1.7] text-ink/75" data-id="element-265" data-mp="1a405tpwa5jcr">
          Print one, put it on the table with a pile of cardboard, and leave the room. That is the
          whole method. Everything else here is simply more of it, arranged so you can find the
          right thing on a wet Tuesday afternoon.
        </p>

        <div className="mt-8 border-t border-rule pt-4" data-id="element-266" data-mp="38ibannfmgwrp">
          <p className="font-display text-[16px] font-semibold text-ink" data-id="element-267" data-mp="lax226f3y264">Ada &amp; Marcus Whitlow</p>
          <p className="mt-1 font-sans text-[11px] tracking-[0.1em] text-muted" data-id="element-268" data-mp="gasuj5w6ghs1">
            Little Engineer Press
          </p>
        </div>
      </div>
    </section>;
}